import copy from 'copy-to-clipboard';
import { Button, ButtonProps, Tooltip } from 'antd';
import { useState } from 'react';

type CopyToClipboardButtonProps = {
    textToCopy: string;
    beforeMessage?: string;
    afterMessage?: string;
} & ButtonProps;

const CopyToClipboardButton = ({
    textToCopy, icon,
    children,
    type,
    beforeMessage = 'Copy Url',
    afterMessage = 'Copied' }: CopyToClipboardButtonProps) => {
        
    const tooltipMessage = beforeMessage;
    const [toolTipText, setToolTipText] = useState(tooltipMessage);

    const handleCopyClick = () => {
        copy(textToCopy);
        setToolTipText(afterMessage);
        setTimeout(() => {
            setToolTipText(tooltipMessage);
        }, 1000);
    };

    return (
        <Tooltip title={toolTipText}>
            <Button type={type} icon={icon} onClick={handleCopyClick}>
                {children}
            </Button>
        </Tooltip>
    );
};

export default CopyToClipboardButton;